import { render } from "./LoadingOverlay.vue?vue&type=template&id=10cc352d&scoped=true"
const script = {}

import "./LoadingOverlay.vue?vue&type=style&index=0&id=10cc352d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10cc352d"]])

export default __exports__